import Vue from 'vue'
import router from './router'
import store from './store'
import _ from "lodash"
import animate from 'animate.css'

import clipboard from 'clipboard';
import Icon from 'vue-svg-icon/Icon.vue'
import './config/rem'
import App from './App'
import Vconsole from 'vconsole'
import Router from "vue-router";
import LazyLoad from "vue-lazyload"
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'


import msg from '@/utils/msg'

import routerIntercept from '@/utils/routerIntercept'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)



Vue.use(Router)
Vue.use(DatetimePlugin)
Vue.use(animate)
Vue.component('icon', Icon)
Vue.prototype._ = _
Vue.use(WechatPlugin)
Vue.use(msg);
Vue.use(routerIntercept);
Vue.use(LazyLoad);
Vue.prototype.clipboard = clipboard;

Vue.prototype.compatibleIOS = () => {
setTimeout(() => {
const scrollHeight =
document.documentElement.scrollTop || document.body.scrollTop || 0;
window.scrollTo(0, Math.max(scrollHeight - 1, 0));
}, 100);
}

Vue.config.productionTip = false

/** 检测当前点击是否为自身元素(点击空白处隐藏模态框等操作) */
Vue.directive('clickoutside', {

bind(el, binding, vnode) {
function documentHandler(e) {

if (el.contains(e.target)) {
return false;
}

if (binding.expression) {

binding.value(e);
}
}

el.__vueClickOutside__ = documentHandler;
document.addEventListener("click", documentHandler);
},
update() { },
unbind(el, binding) {

document.removeEventListener("click", el.__vueClickOutside__);
delete el.__vueClickOutside__;
}
})


/* eslint-disable no-new */

if (process.env.NODE_ENV != "production") {
new Vconsole()
}
new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js